import script from "./VPanelRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./VPanelRow.vue?vue&type=script&setup=true&lang=ts"

import "./VPanelRow.vue?vue&type=style&index=0&id=2e1f9e3a&lang=scss"

const __exports__ = script;

export default __exports__